import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { waLink } from '@/config/contact';

const WhatsAppFloat = () => {
  const [isHovered, setIsHovered] = useState(false);
  const whatsappUrl = waLink("Hi! I'm interested in BITZ Club membership. Please share more details.");

  return (
    <div className="fixed bottom-6 right-4 sm:right-6 z-50" data-testid="whatsapp-float">
      <style>{`
        @keyframes wa-pulse-ring {
          0% { box-shadow: 0 0 0 0 rgba(34,197,94,0.45); }
          70% { box-shadow: 0 0 0 14px rgba(34,197,94,0); }
          100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
        }
      `}</style>

      {/* Tooltip */}
      {isHovered && (
        <div className="absolute bottom-16 right-0 bg-white text-gray-800 px-4 py-2 rounded-lg shadow-lg whitespace-nowrap animate-fade-in">
          <p className="text-sm font-medium">Chat with us on WhatsApp!</p>
          <div className="absolute bottom-[-6px] right-6 w-3 h-3 bg-white transform rotate-45"></div>
        </div>
      )}

      {/* Floating Button (box-shadow ring instead of animate-ping to avoid layout overflow) */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        style={{ animation: 'wa-pulse-ring 2.4s ease-out infinite' }}
        data-testid="whatsapp-float-btn"
      >
        <MessageCircle className="w-7 h-7 text-white" />
      </a>
    </div>
  );
};

export default WhatsAppFloat;
